import { Controller } from '@hotwired/stimulus'
import { rememberLocation } from '@/lib/list-return'

export default class extends Controller {
  static override values = { list: String }

  declare readonly listValue: string

  override connect() {
    rememberLocation(window.location, undefined, this.listValue)
  }
}
